module.exports = "//static.hsappstatic.net/ContentComponents/static-2.70305/img/case-study-zero.png"